export default __webpack_public_path__ + "static/media/PPDB.8fb5ce34.svg";